import { useState } from 'react'

export const useGuarantorFirstNegativeFeedback = () => {
  const [isShowModal, setIsShowModal] = useState(false)

  return [isShowModal, setIsShowModal]
}
